import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProveedorService } from '../proveedor.service';

@Component({
  selector: 'app-proveedor-update',
  templateUrl: './proveedor-update.component.html',
  styleUrls: ['./proveedor-update.component.scss']
})
export class ProveedorUpdateComponent implements OnInit {

  form: FormGroup = new FormGroup({});
  estado = [{ id: 1, name: 'Activo' }, { id: -1, name: 'Inactivo' }];
  estado_seleccionado!: number;
  @Input() element: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    public service: ProveedorService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: [],
      nombre: ['', [Validators.required]],
      apellido: [],
      razon_social: [],
      email: ['', [Validators.required, Validators.email]],
      fono: [],
      fono2: [],
      direccion: [''],
      empresa_id: ['', [Validators.required]],
    });
    this.estado_seleccionado = this.element.estado;
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro.", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }
}
